import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-parametrizacion-visualizar',
  templateUrl: './parametrizacion-visualizar.component.html',
  styleUrls: ['./parametrizacion-visualizar.component.scss']
})
export class ParametrizacionVisualizarComponent implements OnInit {

  @Input() title: string = '';
  @Input() msg: string = '';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
